import { render } from "./bookingView.vue?vue&type=template&id=b23fa7fc&ts=true"
import script from "./bookingView.vue?vue&type=script&lang=ts"
export * from "./bookingView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__